export default "__VITE_ASSET__CUZ7K925__"